import RatingAnswer from './RatingAnswer.vue'
import RatingView from './RatingView.vue'

export default {
  RatingAnswer,
  RatingView

}



// WEBPACK FOOTER //
// ./src/components/Rating/index.js